import type { LightningKeyframe, LightningPoint } from './config/types';

// The next shape becomes the current shape at the cycle boundary. Smoothstep
// gives zero velocity on both sides of that handoff, without rounding bends.
export const lightningMorph = (age: number, frequency: number) => {
  const time = Math.max(0, age) * Math.max(0, frequency);
  const cycle = Math.floor(time);
  const fraction = time - cycle;
  return { cycle, blend: fraction * fraction * (3 - 2 * fraction) };
};

export const lightningReveal = (age: number, duration: number) => {
  const progress = Math.min(1, Math.max(0, age) / Math.max(0.001, duration));
  return 1 - Math.pow(1 - progress, 3);
};

// Stateless sampling makes replay and backward scrubbing identical. Tracks are
// authored in ascending time order; intensity zero is a genuine blackout.
export const sampleLightningTrack = (
  age: number,
  track?: LightningKeyframe[]
) => {
  if (!track?.length)
    return { intensity: 1, endOffset: [0, 0, 0] as LightningPoint };
  const nextIndex = track.findIndex((key) => key.time > age);
  const a =
    track[nextIndex < 0 ? track.length - 1 : Math.max(0, nextIndex - 1)];
  const b = track[nextIndex < 0 ? track.length - 1 : nextIndex];
  const t =
    a === b ? 0 : Math.max(0, Math.min(1, (age - a.time) / (b.time - a.time)));
  return {
    intensity: a.intensity + (b.intensity - a.intensity) * t,
    endOffset: a.endOffset.map(
      (value, axis) => value + (b.endOffset[axis] - value) * t
    ) as LightningPoint,
  };
};
